// extracted by mini-css-extract-plugin
module.exports = {"bookmarks-container":"bookmark_bookmarks-container__3BbuV","bookmark-list":"bookmark_bookmark-list__1M_iq"};